import React from 'react';
import { Icon } from '../../../shared/utils/icons';

const FilterGroup = ({ title, children }) => (
    <section className="filter-group">
        <h3>{title}</h3>
        <div className="filter-options">{children}</div>
    </section>
);

const Option = ({ active, onClick, children }) => (
    <button className={`filter-option${active ? ' active' : ''}`} onClick={onClick}>
        {children}
    </button>
);

// Group month options by year (value is "YYYY-MM") so the drawer shows a year
// sub-header above each block. Integer-like keys keep ascending (chronological) order.
const groupByYear = (months) =>
    months.reduce((acc, m) => {
        const year = m.value.slice(0, 4);
        (acc[year] = acc[year] || []).push(m);
        return acc;
    }, {});

const FilterDrawer = ({ open, onClose, options, state, toggle, clearAll, count }) => (
    <>
        <div className={`ep-scrim${open ? ' is-open' : ''}`} onClick={onClose} />
        <aside className={`filter-drawer${open ? ' is-open' : ''}`} aria-hidden={!open}>
            <div className="drawer-head">
                <div>
                    <h2>Find the right event</h2>
                    <p className="drawer-sub">Filter events by chapter, theme and month.</p>
                </div>
                <button className="close-btn" onClick={onClose} aria-label="Close filters">
                    <Icon name="close" size={17} strokeWidth={2} />
                </button>
            </div>

            <div className="drawer-body">
                <FilterGroup title="Chapter community">
                    {options.chapters.map((c) => (
                        <Option key={c.slug} active={state.chapters.includes(c.slug)} onClick={() => toggle('chapters', c.slug)}>
                            {c.name}
                        </Option>
                    ))}
                </FilterGroup>

                <FilterGroup title="Event themes">
                    {options.themes.map((t) => (
                        <Option key={t} active={state.themes.includes(t)} onClick={() => toggle('themes', t)}>
                            {t}
                        </Option>
                    ))}
                </FilterGroup>

                <section className="filter-group">
                    <h3>Month</h3>
                    {Object.entries(groupByYear(options.months)).map(([year, months]) => (
                        <div key={year} className="filter-year">
                            <span className="filter-year__label">{year}</span>
                            <div className="filter-options">
                                {months.map((m) => (
                                    <Option key={m.value} active={state.months.includes(m.value)} onClick={() => toggle('months', m.value)}>
                                        {m.label}
                                    </Option>
                                ))}
                            </div>
                        </div>
                    ))}
                </section>
            </div>

            <div className="drawer-foot">
                <button className="btn ghost" onClick={clearAll}>
                    <Icon name="reset" size={13} strokeWidth={2} /> Clear all
                </button>
                <button className="btn primary" onClick={onClose}>
                    Show {count} events
                </button>
            </div>
        </aside>
    </>
);

export default FilterDrawer;
